export const AYANA_KOMODO = "AYANA Komodo Waecicu Beach";
export const AYANA_LAKODIA = "AYANA Lako Di'a";
export const AYANA_BALI = "AYANA Bali";
export const AYANA_RESORT_AND_SPA = "AYANA Resort Bali";
export const RIMBA_JIMBARAN_BALI = "RIMBA by AYANA Bali";
export const VILLAS_AYANA_RESORT_BALI = "AYANA Villas Bali";
export const AYANA_SEGARA_BALI = "AYANA Segara Bali";
export const AYANA_MIDPLAZA_JAKARTA = "AYANA MIDPLAZA, JAKARTA";
export const ROCKBAR_RESTAURANT = "rockbar";

export const ROCKBAR_BALI = "Rock Bar BALI";

export const BALI = "Bali";
export const KOMODO = "Komodo";
export const JAKARTA = "JAKARTA";

export const AYANA_KOMODO_ID = "4";
export const AYANA_LAKODIA_ID = "5";
export const AYANA_RESORT_ID = "2";
export const AYANA_RIMBA_JIMBARAN_ID = "1";
export const AYANA_VILLA_ID = "3";
export const AYANA_JAKARTA_ID = "7";
export const AYANA_SEGARA_ID = "9";

export const ARSB_HOTEL_CODE = "ARSB";
export const RJB_HOTEL_CODE = "RJB";
export const VILLA_HOTEL_CODE = "VILLA";
export const KOMODO_HOTEL_CODE = "AKWB";
export const LAKODIA_HOTEL_CODE = "LKD";
export const SEGARA_HOTEL_CODE = "SEGARA";

export const JAKARTA_LOCATION = "Jakarta";
